import React from 'react';
import splitOnFirst from 'split-on-first';

import ArtWorkThumbnail from '../../ArtworkThumbnail';
import { SanitizedLineItem } from '../../../../../types/order/Order';
import { dispatchAccountEvent } from '../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import useFileValidation from '../../../../../hooks/useFileValidation';

interface LineItemArtworkProps {
  lineItem: SanitizedLineItem;
}

const LineItemArtwork = ({ lineItem }: LineItemArtworkProps) => {
  const fileValidation = useFileValidation(lineItem);

  const {
    custom: {
      fields: {
        mcpDocumentsSource, userSelection,
      },
    },
  } = lineItem;

  const isDeliveredFileValid = fileValidation.isSuccess && fileValidation?.data[lineItem.id]?.valid;

  return (
    <ArtWorkThumbnail
      lineItem={lineItem}
      documentReference={mcpDocumentsSource && splitOnFirst(mcpDocumentsSource[0], ':')[1]}
      isDeliveredFileValid={isDeliveredFileValid}
      userSelection={userSelection}
      clickedCallback={() => dispatchAccountEvent('order_detail_interaction', 'open_preview_modal')}
      size="md"
    />
  );
};

export default LineItemArtwork;
